import React, { FC, useMemo, useEffect } from 'react';

import { HttpClient } from '@wix/http-client';
import { listOffers } from '@wix/ambassador-dealer-v1-serving-offer/http';
import { injectStoresV2 } from '../../stores/injectStoresV2';
import { ExperimentsStore } from '../../../stores/ExperimentsStore';
import { ConfigStore } from '../../stores/ConfigStore';
import s from './index.scss';

// TODO: remove when it close 'specs.funnel.templatePageUiV2' and specs.funnel.templatePageUiV2Fixes and specs.funnel.templatePageUiV2WithAnimation

export const DealerBannerNewCmp: FC<{
  bannerPosition: string;
  experimentsStore: ExperimentsStore;
  configStore: ConfigStore;
}> = ({ bannerPosition, experimentsStore, configStore }) => {
  const [isShowBanner, setShowBanner] = React.useState(false);

  const httpClient = useMemo(() => new HttpClient(), []);

  useEffect(() => {
    httpClient
      .request(
        listOffers({
          realEstateId: bannerPosition,
        }),
      )
      .then(({ data }) => {
        if (data && data?.offers && data?.offers?.length && data.offers?.[0]?.asset?.payloadJson?.length) {
          setShowBanner(true);
        }
      });
  }, [bannerPosition, httpClient]);

  if (
    (experimentsStore.is('specs.funnel.templatePageUiV2Fixes', 'true') ||
      experimentsStore.is('specs.funnel.templatePageUiV2WithAnimation', 'true')) &&
    !isShowBanner
  ) {
    return null;
  }

  return (
    <div className={s.container}>
      <span className={s.title}>Want Help Picking a Template?</span>
      <span className={s.description}>Get tips for finding the template that’s right for you</span>
      <a
        href="https://support.wix.com/en/article/choosing-the-best-template-for-your-site"
        className={s.link}
        target="_blank"
      >
        Help Me Choose
      </a>
    </div>
  );
};

export const DealerBannerNew = injectStoresV2('configStore', 'experimentsStore')(DealerBannerNewCmp);
